import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CommonRzmService} from './common-rzm.service';
import {ServerConstants} from '../model/ServerConstants';
import {RestEndPoints} from '../model/RestEndPoints';
import {AuthService} from './auth.service';
import {RejectChangeRequestCommand} from '../generate/RejectChangeRequestCommand';
import {ApproveChangeRequestCommand} from '../generate/ApproveChangeRequestCommand';
import {WithdrawChangeRequestCommand} from '../generate/WithdrawChangeRequestCommand';
import {TechCheckRetestCommand} from '../generate/TechCheckRetestCommand';
import {ResendUserInvitationCommand} from "../generate/ResendUserInvitationCommand";

@Injectable({
  providedIn: 'root'
})
export class ChangeRequestService extends CommonRzmService {

  constructor(@Inject(HttpClient) http, @Inject('env') environment, @Inject(AuthService) auth) {
    super(http, environment, auth);
  }


  getListOfChangeRequests(page: number, size: number, type: string, searchText: string, descendingSort?: boolean): Observable<any> {
    const url = this.getRestEndPoint() + RestEndPoints.GET_CHANGE_REQUESTS + '?page=' + page + '&size=' + size + '&type=' + type + '&search=' + searchText+ '&descendingSort=' + descendingSort;
    return this.getResponse<any>(url);
  }

  getChangeRequestDetails(changeRequestID: string): Observable<any> {
    const url = this.getRestEndPoint() + RestEndPoints.GET_CHANGE_REQUEST_DETAILS + changeRequestID;
    return this.getResponse(url);
  }

  getTechnicalCheckResponse(changeRequestID: string, techCheckID: string): Observable<any> {
    const url = this.getRestEndPoint() + RestEndPoints.GET_TECH_CHECK_RESULT_DETAILS + changeRequestID + RestEndPoints.URL_SEPARATER + techCheckID;
    return this.getResponse(url);
  }

  resendUserInvitation(userId: string, userEmail: string): Observable<any> {
    const url = this.getRestEndPoint() + RestEndPoints.COMMON_COMMAND;
    const resendUserInvitationCommand: ResendUserInvitationCommand = {};
    resendUserInvitationCommand.userId = userId;
    resendUserInvitationCommand.userEmail = userEmail;
    return this.getPostResponse(url, this.createCommandEnvelope(resendUserInvitationCommand, ServerConstants.RESEND_USER_INVITATION_COMMAND));
  }

  withdrawRequest(changeRequestID: string, comment: string) {
    const url = this.getRestEndPoint() + RestEndPoints.COMMON_COMMAND;

    const withdrawChangeRequestCommand: WithdrawChangeRequestCommand = {};
    withdrawChangeRequestCommand.changeRequest = changeRequestID;
    withdrawChangeRequestCommand.comment = comment;
    return this.getPostResponse(url, this.createCommandEnvelope(withdrawChangeRequestCommand, ServerConstants.WITHDRAW_CHANGE_REQUEST_COMMAND));
  }

  techCheckRetestRequest(changeRequestID: string) {
    const url = this.getRestEndPoint() + RestEndPoints.COMMON_COMMAND;

    const techCheckRetestCommand: TechCheckRetestCommand = {};
    techCheckRetestCommand.changeRequest = changeRequestID;
    return this.getPostResponse(url, this.createCommandEnvelope(techCheckRetestCommand, ServerConstants.TECH_CHECK_RETEST_COMMAND));
  }

  contactConfirmationResponse(changeRequestID: string, response: 'APPROVE' | 'REJECT', comment: string, userID: string) {
    const url = this.getRestEndPoint() + RestEndPoints.COMMON_COMMAND;

    if (response === 'APPROVE') {
      const approveChangeRequestCommand: ApproveChangeRequestCommand = {};
      approveChangeRequestCommand.changeRequest = changeRequestID;
      approveChangeRequestCommand.comment = comment;
      approveChangeRequestCommand.userId = userID;
      return this.getPostResponse(url, this.createCommandEnvelope(approveChangeRequestCommand, ServerConstants.APPROVE_CHANGE_REQUEST_COMMAND));

    } else {
      const rejectChangeRequestCommand: RejectChangeRequestCommand = {};
      rejectChangeRequestCommand.changeRequest = changeRequestID;
      rejectChangeRequestCommand.comment = comment;
      rejectChangeRequestCommand.userId = userID;
      return this.getPostResponse(url, this.createCommandEnvelope(rejectChangeRequestCommand, ServerConstants.REJECT_CHANGE_REQUEST_COMMAND));

    }
  }

  acTCcontactConfirmationResponse(changeRequestID: string, response: boolean, comment: string, email: string) {
    const url = this.getRestEndPoint() + RestEndPoints.AC_TC_CONFIRMATION;
    let contactConfirmationCommand = {
      userEmail: email,
      changeRequest: changeRequestID,
      confirm: response,
      comment: comment
    };
    return this.getPostResponseUnAuthenticatedRequest(url, contactConfirmationCommand);


  }

}
